export const TOKTOK_SUBJECT = {
  KOR: '국어',
  MAT: '수학',
  SOC: '사회',
  SCI: '과학',
  ENG: '영어',
  // RWR: 'RWR'
  // CEA: 'CEA'
};

export const TOKTOK_SCHOOL_CLASS = {
  ELE: 'E',
  MID: 'M',
  HIGH: 'H'
  // CHILD: '유아',
  // SPECIAL: '특수'
};
export const TOKTOK_GRADE = {
  ALL: undefined,
  COMMON: 0,
  FIRST: 1,
  SECOND: 2,
  THIRD: 3,
  FOURTH: 4,
  FIFTH: 5,
  SIXTH: 6  
  // ECT: 99
};
export const TOKTOK_SEMESTER = {
  ALL: undefined,
  FIRST: 1,
  SECOND: 2
};

export const ITT_FILTER_DATA = {
  subject: [
    {
      key: 'KOR',
      value: '국어'
    },
    {
      key: 'MAT',
      value: '수학'
    },
    {
      key: 'SOC',
      value: '사회'
    },
    {
      key: 'SCI',
      value: '과학'
    },
    {
      key: 'ENG',
      value: '영어'
    }
    // {
    //   key: 'RWR',
    //   value: 'RWR'
    // }
    // {
    //   key: 'CEA',
    //   value: 'CEA'
    // }
  ],
  schoolClass: [
    {
      key: 'ELE',
      value: 'E'
    },
    {
      key: 'MID',
      value: 'M'
    },
    {
      key: 'HIGH',
      value: 'H'
    }
    // {
    //   key: 'CHILD',
    //   value: '유아'
    // },
    // {
    //   key: 'SPECIAL',
    //   value: '특수'
    // }
  ],
  grade: [
    {
      key: 'ALL',
      value: undefined
    },
    {
      key: 'COMMON',
      value: 0
    },
    {
      key: 'FIRST',
      value: 1
    },
    {
      key: 'SECOND',
      value: 2
    },
    {
      key: 'THIRD',
      value: 3
    },
    {
      key: 'FOURTH',
      value: 4
    },
    {
      key: 'FIFTH',
      value: 5
    },
    {
      key: 'SIXTH',
      value: 6
    }    
    // {
    //   key: 'ECT',
    //   value: 99
    // }
  ],
  semester: [
    {
      key: 'ALL',
      value: undefined
    },
    {
      key: 'FIRST',
      value: 1
    },
    {
      key: 'SECOND',
      value: 2
    }
    // {
    //   key: 'COMMON',
    //   value: 3
    // }
  ]
};

export const ACTIVELINK_TYPE = {
  NONE: 'none',
  CANVAS: 'canvas',
  ACTIVELINK: 'activelink'
};
